export default "__VITE_ASSET___89oBCWf__"